import { useNavigate } from "react-router-dom";
import { useInsightsCtx } from "./InsightsLayout";
import BuildingEventsTable from "./buildingEventsTable";
import PortfolioKpis from "./PortfolioKpis";
import PortfolioOverview from "./PortfolioOverview";
import Spinner from "../../components/ui/Spinner";

export default function BuildingsPage() {
  const navigate = useNavigate();
  const {
    buildings,
    buildingsLoading,
    tenantName,
    startDate,
    endDate,
    searchQuery,
  } = useInsightsCtx();

  if (buildingsLoading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner size={96} />
      </div>
    );
  }

  return (
    <>
      <PortfolioKpis
        buildings={buildings}
        startDate={startDate}
        endDate={endDate}
      />
      <PortfolioOverview
        buildings={buildings}
        startDate={startDate}
        endDate={endDate}
      />
      <BuildingEventsTable
        data={buildings}
        loadUnitsData={(buildingId: string) =>
          navigate(`/insights/properties/${buildingId}`)
        }
        organization={tenantName}
        startDate={startDate}
        endDate={endDate}
        searchQuery={searchQuery}
      />
    </>
  );
}
